export function loadMoreInit() {

	if (document.getElementById("articles") !== null) {
		let currentPage = 1;
		let loadedPosts = document.getElementById("articles").getAttribute('data-per-page');
		const maxResults = document.getElementById("articles").getAttribute('data-max-results');

		document.getElementById("load-more").addEventListener("click", async () => {
			currentPage++;
			const paged = currentPage;
			const url = "/wp/wp-admin/admin-ajax.php";
			
			try {
				const response = await fetch(url, {
				method: "POST",
				headers: {
					"Content-Type": "application/x-www-form-urlencoded", // Important for sending data as form data
				},
				body: `action=leona_load_more&paged=${currentPage}&loadedPosts=${loadedPosts}&maxResults=${maxResults}`, // Construct the POST data
				});
			
				const responseData = await response.json();
				if (paged >= responseData.max) {
				document.getElementById("load-more").style.display = "none";
				}
				document
				.querySelector(".articles")
				.insertAdjacentHTML("beforeend", responseData.html);
				document.querySelector('#posts-amount').innerText = responseData.resultAmount;
				loadedPosts = parseInt(loadedPosts) + parseInt(responseData.loadedPosts);

			} catch (error) {
				console.log("Error: ", error);
			}
		});
	}
}